export const getWizardItems = (t) => [
  { key: 'select', label: t('fleetTask.transferDeliveryModal.wizard.selectDestinationFleetTask') },
  { key: 'review', label: t('fleetTask.transferDeliveryModal.wizard.review') },
]
